import { TextField } from "@engaging-tech/components"
import React from "react"
import styled from "styled-components"

const ExtendTextField = styled(TextField)`
  input {
    background: white;
    border: 1px solid #003e4c;
  }
`

const TextSearchInput = ({ placeholder = "", value, onChangeValue }) => {
  const handleInputChange = ({ target: { value: inputValue } }) => onChangeValue(inputValue)

  return (
    <ExtendTextField
      id="searchTextField"
      noLabel
      fontSize={14}
      height={36}
      borderRadius={100}
      noHighlight
      onChange={handleInputChange}
      value={value}
      placeholder={placeholder}
      iconName="search"
      iconStyle={{ color: "primary.0" }}
    />
  )
}

export default TextSearchInput
